import React, { FocusEventHandler, forwardRef } from 'react'
import MaskedInput from 'react-text-mask'
import { InputBaseComponentProps } from '@mui/material/InputBase/InputBase'
import * as R from 'ramda'

import { handleMaskInputFocus, isDigit } from '../../utils'

const US_PHONE_MASK = [
  '(',
  /[2-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /[2-9]/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
const US_PHONE_MASK1 = [
  '1',
  ' ',
  '(',
  /[2-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /[2-9]/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
const FREE_MASK = ['+', ...Array(20).fill(/[A-Za-z0-9]/)]

const US_REGEXP = /^((\+)?1)?[2-9]\d\d[2-9]\d\d\d\d\d\d$/

const matchPhoneNumber = (rawValue: string) => {
  const value = rawValue.replace(/[(]|[)]|[-]|\s/g, '')
  return US_REGEXP.test(value)
}

const isCodeEqual = (code: string) => (value: string) =>
  value.indexOf(code) === 0 ||
  value.indexOf(`+${code}`) === 0 ||
  value.indexOf(`(${code}`) === 0

const getUSMask = (rawValue: string) =>
  isCodeEqual('1')(rawValue) && rawValue[0] !== '+'
    ? US_PHONE_MASK1
    : US_PHONE_MASK

export interface PhoneInputUSProps
  extends Omit<Partial<InputBaseComponentProps>, 'onFocus'> {
  readonly onFocus?: FocusEventHandler<HTMLInputElement>
}

const PhoneInputUS = forwardRef<HTMLDivElement, PhoneInputUSProps>(
  function PhoneInputUS({ onChange, onFocus, ...other }, ref) {
    const mask = (rawValue: string, info?: any) => {
      if (!R.isNil(info.previousConformedValue) || matchPhoneNumber(rawValue)) {
        return getUSMask(rawValue)
      }
      return FREE_MASK
    }

    return (
      <MaskedInput
        showMask
        guide={false}
        mask={mask}
        placeholderChar={'\u2000'}
        ref={inputRef => {
          if (R.is(Function, ref)) {
            const inputElement = inputRef?.inputElement as HTMLInputElement
            ref(inputElement)
          }
        }}
        onChange={event => {
          const { target: { value = '' } = {} } = event
          const digitsCount = value.split('').filter(isDigit).length
          const newEvent =
            digitsCount > 0
              ? event
              : {
                ...event,
                target: {
                  ...event.target,
                  value: '',
                },
              }
          if (onChange) {
            onChange(newEvent)
          }
        }}
        onFocus={handleMaskInputFocus(onFocus)}
        {...other}
      />
    )
  },
)

export default PhoneInputUS
